/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * *

sticky-js - Does exactly what you would expect.

https://rgalus.github.io/sticky-js/

*/

import Sticky from 'sticky-js';

function expandInfoBox() {
    let $sticky_element = $('.events-infobox-plugin');
    $sticky_element.css('transform','translateX(0)');
    $sticky_element.removeClass('events-infobox-plugin--collapsed');
}

function collapseInfoBox() {
    let $sticky_element = $('.events-infobox-plugin');
    let $col = $sticky_element.parents('.col').first();
    let col_width = $col.width();
    let collapsed_button_width = 60; // ananlog CSS
    let offset = col_width - collapsed_button_width;
    $sticky_element.css('transform','translateX('+offset+'px)');
    $sticky_element.addClass('events-infobox-plugin--collapsed');
}

function initInfoBox() {


    /* * * * * * * * * * * * * * * * * * * * * * * * * * * * * *

    Select magic

    */

    // select topics drodown (important: we need to select the actual <select> element in order to get the value, not the dropdown)
    var $events_select = $('.events-infobox-plugin__select.selectpicker');
    var $infobox_button = $('.events-infobox-plugin__link');
    // listen for the change event and open the URL
    $events_select.on('change', function (e) {
        var href = $(this).val();
        if (href.length > 0) {
            $infobox_button.removeClass('disabled');
            $infobox_button.removeAttr('data-softpage-disabled');
            $infobox_button.attr('href',href);
            $(window).trigger('initSoftpageTrigger');
        }
    });


    /* * * * * * * * * * * * * * * * * * * * * * * * * * * * * *

    Sticky magic on desktop only!

    */

    if ($(window).width() >= 768) {

        /* * * * * * * * * * * * * * * * * * * * * * * * * * * * * *

        Set wrapper dimensions on page load

        */

        var $sticky_element = $('.events-infobox-plugin');
        $sticky_element.parent().css({
            'width': $sticky_element.width(),
            'height': $sticky_element.height(),
            'display': 'block',
        });


        /* * * * * * * * * * * * * * * * * * * * * * * * * * * * * *

        Toggle functionality

        */

        $('.events-infobox-plugin-toggle').on('click',function(e){
            // init
            e.preventDefault();
            let $toggle = $(this);
            let $plugin_container = $toggle.parents('.events-infobox-plugin').first();
            $plugin_container.addClass('events-infobox-plugin--manually-toggled');
            if ($plugin_container.hasClass('events-infobox-plugin--collapsed')) {
                expandInfoBox();
            }else {

                collapseInfoBox();
            }
        });


        /* * * * * * * * * * * * * * * * * * * * * * * * * * * * * *

        Sticky settings and Observer Magic

        */

        let $sticky_element = $('.events-infobox-plugin');

        // only start observing if we're logged in and the element exists
        if ($sticky_element.length > 0) {

            // init
            var observer_config, sticky_element_observer;
            let header_height = $('.invisible-header-compact-mode-size').height();
            let offset = 30;

            // set sticky margin
            $sticky_element.attr('data-margin-top', header_height + offset);

            // init sticky element
            const sticky = new Sticky('.events-infobox-plugin');
            const sticky_scrolltop_offset = -300;

            // observer settings
            observer_config = {
                attributes: true, // this is enough in our case
                childList: false,
                characterData: false
            };

            // instantuation MutationObserver
            sticky_element_observer = new MutationObserver(function (mutations) {
                mutations.forEach(function (mutation) {
                    var rect = $sticky_element.parent().get(0).getBoundingClientRect();
                    var placeholder_position_top = rect.top;
                    var newVal = $(mutation.target).prop(mutation.attributeName);
                    if (mutation.attributeName === "class") {
                        // as soon as the user toggles the box manually, we're not listening anymore
                        if (newVal.search('events-infobox-plugin--manually-toggled') == -1) {
                            if ( newVal.search('events-infobox-plugin--sticky') > 0 ) {
                                if ( placeholder_position_top <= sticky_scrolltop_offset ) {
                                    collapseInfoBox();
                                }else {
                                    expandInfoBox();
                                }
                            }
                        }
                    }
                });
            });

            // Let's observe!
            sticky_element_observer.observe($sticky_element.get(0), observer_config);

        }

    }
}

$(function(){

    // on page load
    initInfoBox();

    $(window).on('viewportWidthHasChanged',function(){
        initInfoBox();
    });

});



// WEBPACK FOOTER //
// ./static/js/modules/events-infobox.js